import React from "react";
import { Card, Row, Col, ButtonGroup, Button } from "react-bootstrap";
import { AnalystImage } from "pages/AnalystDirectory/parts/AnalystImage";
import { FaIcon } from "lib/FaIcon";
import { _t, i18n } from "app/i18n/i18n";
import { AnalystSubscribeButton } from "./AnalystSubscribeButton";
import { features } from "app/features";

export const AnalystProfileCard = ({ profile }) => (
  <Card className="py-3 mx-3 my-3 shadow">
    <Row>
      <Col md={5}>
        <PictureProfileSection profile={profile} />
      </Col>
      <Col md={7}>
        <MainProfileSection profile={profile} />
        <ActionButtons profile={profile} />
      </Col>
    </Row>
  </Card>
);

const PictureProfileSection = ({ profile, lang = i18n.getLanguage() }) => (
  <section className="d-block mx-3 clearfix">
    <AnalystImage {...profile} />

    <Card.Body className="text-center">
      <h3 className="text-primary font-weight-lighter h3 mb-3">
        {profile.fullName[lang]} <br />
      </h3>

      <Card.Subtitle className="mb-2 text-muted">
        <h6 className="my-1 mb-2">{profile.title}</h6>
        <span>
          {profile.speciality && profile.speciality.group[lang]}/{" "}
          {profile.speciality && profile.speciality.speciality[lang]}
        </span>
        <br />
        <span className="font-weight-normal">{profile.coverage}</span>
      </Card.Subtitle>
    </Card.Body>
  </section>
);

const ActionButtons = ({ profile }) => {
  return (
    <section className="mx-3 mt-4">
      <ButtonGroup className="d-flex flex-column flex-md-row mx-auto" style={{ maxWidth: "500px" }}>
        {features.analystSubscriptions && <AnalystSubscribeButton {...profile} />}

        {profile.telephone && (
          <Button href={"tel:" + profile.telephone} variant="info p-2 text-white text-center">
            <FaIcon icon="fas fa-2x fa-phone mr-1" align="top" />
            <div>{profile.telephone}</div>
          </Button>
        )}

        <Button href={"mailto:" + profile.email} variant="success p-2 text-white">
          <FaIcon icon="fas fa-2x fa-envelope mr-1" align="top" />
          <div>{_t("Message")}</div>
        </Button>
      </ButtonGroup>
    </section>
  );
};

const MainProfileSection = ({ profile }) => (
  <section className="mx-3">
    {profile.departmentGroup && (
      <Card.Text className="mt-4">
        <span className="text-muted">{_t("Sub-Sector")}</span>
        <br />
        {profile.departmentGroup}
      </Card.Text>
    )}

    <hr />
    <span className="text-muted">{_t("Profile")}</span>
    <br />
    {profile.background || "No profile information available."}
    <hr />
  </section>
);
